module.exports = __webpack_public_path__ + "img/video3.d4ba7e87.jpg";